// components/common/labelWithIcon/LabelWithIcon.tsx
import { OverridableComponent } from "@mui/material/OverridableComponent"
import { SvgIconTypeMap } from "@mui/material"
import { ForwardRefExoticComponent, RefAttributes } from "react"
import { LucideProps } from "lucide-react"

import clsx from "clsx"
import NotificationBadge from "components/common/notifications/NotificationBadge"

export type IconType =
  | (OverridableComponent<SvgIconTypeMap<{}, "svg">> & { muiName: string })
  | ForwardRefExoticComponent<Omit<LucideProps, "ref"> & RefAttributes<SVGSVGElement>>;

export type NotificationBadgeType = "success" | "danger";

export interface NotificationConfig {
  type: NotificationBadgeType;
  count: number;
  pulse?: boolean;
}

export type LabelWithIconProps = {
  label: string;
  Icon: IconType;
  notification?: NotificationConfig;
  style?: {
    mainStyle?: string;
    labelStyle?: string;
    iconStyle?: string;
  };
};

const LabelWithIcon = ({ label, Icon, notification, style }: LabelWithIconProps) => {
  return (
    <div className={clsx("text-gray1 flex items-center justify-between", style?.mainStyle)}>
      <div className="flex items-center">
        <Icon size={20} className={style?.iconStyle} />
        <p
          className={clsx(
            "ml-2 text-lg font-semibold leading-[0px] text-sm",
            style?.labelStyle,
          )}>
          {label}
        </p>
      </div>
      {notification && notification.count > 0 && (
        <NotificationBadge notification={notification} />
      )}
    </div>
  )
}

export default LabelWithIcon